import React from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';

/**
 * Layout for Admin section: renders child route content and redirects /admin to /admin/dashboard.
 */
const AdminLayout: React.FC = () => {
    const location = useLocation();
    if (location.pathname === '/admin' || location.pathname === '/admin/') {
        return <Navigate to="/admin/dashboard" replace />;
    }
    return <Outlet />;
};

export default AdminLayout;
